import axios from "axios";

const update = payload =>
  axios.put(`/api/v1/organization_settings/update`, payload, {
    header: {
      "Content-Type": "multipart/form-data",
    },
  });

const deleteLogo = () => axios.delete(`/api/v1/organization_settings/id`);

const settingsApi = { update, deleteLogo };

export default settingsApi;
